module.exports = __webpack_public_path__ + "static/img/before5.a18a7f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/orgextension/before5.jpg
// module id = 6zm1
// module chunks = 9